import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockId, setAttributes } ) {
	const unique = blockId
		? `.alpha-heading-blocks.alpha-heading-block-${ blockId }`
		: '.wp-block-alphablock-heading';
	const {
		containerBorder,
		containerBorderRadius,
		margin,
		padding,
		minHeight,
		alignment,
		verticalAlignment,
		enableBackground,
		backgroundType,
		backgroundColor,
		backgroundImage,
		enableBottomLine,
		bottomLineColor,
		bottomLineWidth,
		bottomLineHeight,
		bottomLineAlignment,
		bottomLineMargin,
		enableTopLine,
		topLineColor,
		topLineWidth,
		topLineHeight,
		topLineAlignment,
		topLineMargin,
		typography,
		textColor,
		enableHover,
		hoverBackgroundColor,
		hoverBorder,
		hoverBorderRadius,
		hoverTextColor,
		subHeadingMargin,
		subHeadingTypography,
		subHeadingColor,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.border( containerBorder ),
			GenerateCss.borderRadius( containerBorderRadius ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
			GenerateCss.lengthProp( 'min-height', minHeight ),
			GenerateCss.css( 'text-align', alignment ),
			GenerateCss.css( 'justify-content', verticalAlignment ),
			GenerateCss.css( 'position', 'relative' ),
			GenerateCss.background( {
				enableBackground,
				backgroundType,
				backgroundColor,
				backgroundImage,
			} ),
		],
		[ `${ unique }::after, .block-editor-block-list__layout ${ unique }.block-editor-block-list__block:not([contenteditable=true]):focus::after` ]:
			enableBottomLine
				? [
						{
							initial: {
								content: '""',
								position: 'absolute',
								bottom: '0',
								top: 'initial',
							},
						},
						GenerateCss.backgroundColor( bottomLineColor ),
						GenerateCss.lengthProp( 'width', bottomLineWidth ),
						GenerateCss.lengthProp( 'height', bottomLineHeight ),
						bottomLineAlignment === 'center'
							? {
									initial: {
										left: '50%',
										transform: 'translateX(-50%)',
									},
							  }
							: bottomLineAlignment === 'right'
							? { initial: { right: '0' } }
							: { initial: { left: '0' } },
						GenerateCss.margin( bottomLineMargin ),
				  ]
				: [],
		[ `${ unique }::before, .block-editor-block-list__layout ${ unique }.block-editor-block-list__block:not([contenteditable=true]):focus::before` ]:
			enableTopLine
				? [
						{
							initial: {
								content: '""',
								position: 'absolute',
								bottom: 'initial',
								top: '0',
							},
						},
						GenerateCss.backgroundColor( topLineColor ),
						GenerateCss.lengthProp( 'width', topLineWidth ),
						GenerateCss.lengthProp( 'height', topLineHeight ),
						topLineAlignment === 'center'
							? {
									initial: {
										left: '50%',
										transform: 'translateX(-50%)',
									},
							  }
							: topLineAlignment === 'right'
							? { initial: { right: '0' } }
							: { initial: { left: '0' } },
						GenerateCss.margin( topLineMargin ),
				  ]
				: [],
		[ `${ unique } .alpha-heading` ]: [
			GenerateCss.typography( typography ),
			GenerateCss.textColor( textColor ),
		],
		[ `${ unique }:hover, ${ unique }.is-hover` ]: enableHover
			? [
					GenerateCss.backgroundColor( hoverBackgroundColor ),
					GenerateCss.border( hoverBorder ),
					GenerateCss.borderRadius( hoverBorderRadius ),
			  ]
			: [],
		[ `${ unique } .alpha-heading:hover, ${ unique } .alpha-heading.is-hover` ]:
			enableHover ? [ GenerateCss.textColor( hoverTextColor ) ] : [],
		[ `${ unique } .alpha-subheading` ]: [
			GenerateCss.margin( subHeadingMargin ),
			GenerateCss.typography( subHeadingTypography ),
			GenerateCss.textColor( subHeadingColor ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
